import { z } from 'zod';

import { schemaEuropaceAcceptedOffer } from './acceptedOffer.schema';

export const schemaEuropaceAcceptedOfferResponse = z.object({
    data: z
        .object({
            annahmeJob: schemaEuropaceAcceptedOffer.optional(),
        })
        .optional(),
    errors: z.array(z.unknown()).optional(),
});

export type SchemaEuropaceAcceptedOfferResponse = z.infer<typeof schemaEuropaceAcceptedOfferResponse>;
